exports.airportLocation = (param) => {
  switch (param) {
    case 'Aberdeen':
      return { latitude: 57.203715, longitude: -2.2002149 }
    case 'Belfast City (George Best)':
      return { latitude: 54.6176164, longitude: -5.8740244 }
    case 'Belfast International':
      return { latitude: 54.6556697, longitude: -6.219057817 }
    case 'Birmingham':
      return { latitude: 52.452381, longitude: -1.743507 }
    case 'Bournemouth':
      return { latitude: 50.7810572, longitude: -1.8432162 }
    case 'Bristol':
      return { latitude: 51.3836304, longitude: -2.7135463 }
    case 'Cardiff':
      return { latitude: 51.3939889, longitude: -3.3505723 }
    case 'Doncaster-Sheffield (Robin Hood)':
      return { latitude: 53.480869, longitude: -1.010699 }
    case 'Dublin':
      return { latitude: 53.4264481, longitude: -6.2499098 }
    case 'Durham Tees Valley':
      return { latitude: 54.5093204, longitude: -1.4299756 }
    case 'East Midlands':
      return { latitude: 52.8263618, longitude: -1.3399242 }
    case 'Edinburgh':
      return { latitude: 55.950785, longitude: -3.3636472 }
    case 'Exeter':
      return { latitude: 50.7350408, longitude: -3.4175241 }
    case 'Gatwick':
      return { latitude: 51.1536621, longitude: -0.18206290000000536 }
    case 'Glasgow International':
      return { latitude: 55.865101, longitude: -4.433177 }
    case 'Glasgow Prestwick':
      return { latitude: 55.511234, longitude: -4.610395 }
    case 'Heathrow':
      return { latitude: 51.47002, longitude: -0.454295 }
    case 'Humberside':
      return { latitude: 53.5760454, longitude: -0.3518028 }
    case 'Inverness':
      return { latitude: 57.5432757, longitude: -4.0508974 }
    case 'Leeds Bradford':
      return { latitude: 53.8679434, longitude: -1.6637246 }
    case 'Liverpool':
      return { latitude: 53.3351165, longitude: -2.8545398 }
    case 'London City':
      return { latitude: 51.5048437, longitude: 0.047324 }
    case 'Luton':
      return { latitude: 51.8792496, longitude: -0.3789039 }
    case 'Manchester':
      return { latitude: 53.3554372, longitude: -2.2794919 }
    case 'Newcastle':
      return { latitude: 55.0239619, longitude: -1.7084305 }
    case 'Norwich':
      return { latitude: 52.6767172, longitude: 1.2793283 }
    case 'Shannon':
      return { latitude: 52.6996573, longitude: -8.9168851 }
    case 'Southampton':
      return { latitude: 50.9511565, longitude: -1.3633033 }
    case 'Southend':
      return { latitude: 51.5701898, longitude: 0.6902713 }
    case 'Stansted':
      return { latitude: 51.8850869, longitude: 0.2200046 }
    case 'Dover Port':
      return { latitude: 51.0734069, longitude: 1.1469156 }
    case 'Southampton Port':
      return { latitude: 50.909704, longitude: -1.4357131 }
    default:
      return { latitude: null, longitude: null }
  }
}
